import { render, staticRenderFns } from "./Episodes.vue?vue&type=template&id=982e19da&scoped=true&"
import script from "./Episodes.vue?vue&type=script&lang=js&"
export * from "./Episodes.vue?vue&type=script&lang=js&"
import style0 from "./Episodes.vue?vue&type=style&index=0&id=982e19da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982e19da",
  null
  
)

export default component.exports